import AdminDashboard from './Dashboard'
import AdminContent from './Content'
import AdminProgram from './Program'
import AdminVideo from './Video'
import AdminAudio from './Audio'
import AdminSettings from './Settings'
import AdminEdit from './Edit'
import AdminEditMedia from './edit/Media'

export default {
  AdminDashboard,
  AdminContent,
  AdminProgram,
  AdminVideo,
  AdminAudio,
  AdminSettings,
  AdminEdit,
  AdminEditMedia,
}
